export default "__VITE_PUBLIC_ASSET__b1fe6911__"